import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {NovaSaveVersionModalProps} from './NovaSaveVersionModal';

export type NovaSaveVersionModalPayload = Omit<NovaSaveVersionModalProps, 'onClose'>;

export const showNovaSaveVersionModal = (props: NovaSaveVersionModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_SAVE_VERSION, ...props});
};
